export default "__VITE_ASSET__D6abT1NT__"